"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presets = exports.defaultOptions = void 0;
const presets = {
  chrome: {
    supportedSchemes: ['http', 'https', 'file', 'ftp'
    // 'urn',
    ],
    schemeStarMatchesWs: false
  },
  firefox: {
    supportedSchemes: ['http', 'https', 'ws', 'wss', 'ftp', 'file'
    // 'ftps',
    // 'data',
    ],
    schemeStarMatchesWs: true
  }
};
exports.presets = presets;
const defaultOptions = Object.assign(Object.assign({}, presets.chrome), {
  strict: true
});
exports.defaultOptions = defaultOptions;